import React from 'react'
import { Select } from 'antd'
import { FlexColumn, Flex } from './Container'
import { Text, Tag, TagV2 } from './Text'
import Individual from '../../Images/individual-recipient.png'
import Business from '../../Images/business-recipient.png'
import { toCurrency } from '../../Utils/util'
import Flag from 'react-world-flags'
import { LucideBanknote, LucideCalendarCheck, LucideCheckCheck, LucideEarth, LucideFastForward, LucideLandmark, LucideZap } from 'lucide-react'
import { Divider } from './Input'
import { useTheme } from 'styled-components'
import hexToRgba from 'hex-to-rgba'

const { Option } = Select;

var rcs = [{
    name: 'ACH',
    tag: 'Fast',
    desc: 'Delivers next business day',
    icon: <LucideCheckCheck size={14} />
},{
    name: 'Wire',
    tag: 'Faster',
    desc: 'Delivers within a few hours',
    icon: <LucideFastForward size={14} />
},{
    name: 'Instant',
    tag: 'Fastest',
    desc: 'Delivers within seconds',
    icon: <LucideZap size={14} />
},{
    name: 'International',
    tag: 'Fast',
    desc: '',
    icon: <LucideEarth size={14} />
}];

export const FromAccountOption = (props) => {
    const { account } = props
    const nickNameMaxLen = 18
    var accountNickName = `${(account.nickName || "").trim().substr(0, nickNameMaxLen)}${(account.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`
    return <FlexColumn start fullWidth>
        <Text capitalize title={account.nickName}>{`${(accountNickName || `Business ${account.accountSubType}`)} • ${account.mask}`}</Text>
        <Text size='14px' lightText style={{ marginTop: 4 }}>${toCurrency(account.availableBalance)}</Text>
    </FlexColumn>
}

export const DACAFromAccountOption = (props) => {
    const { account } = props
    const nickNameMaxLen = 18
    return <FlexColumn start fullWidth>
        <Text capitalize title={account.businessName}>{`${account.businessName} • ${account.mask}`}</Text>
        <Text size='14px' lightText style={{ marginTop: 4 }}>${toCurrency(account.availableBalance)}</Text>
    </FlexColumn>
}

export const PaymentMethodOption = (props) => {

    const { paymentMethod, rail } = props
    const { bankDetail, type } = paymentMethod || {}
    const { accountNumber, checkDeliveryType } = bankDetail || {}
    const nickNameMaxLen = 30
    var pmNickName = `${(paymentMethod.nickName || "").trim().substr(0, nickNameMaxLen)}${(paymentMethod.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`

    return <Flex between style={{ width: props.width }}>
        <FlexColumn start>
            <Text title={paymentMethod.nickName}>
                {paymentMethod?.type === "International" ? <Flag style={{ marginRight: 8 }} code={paymentMethod?.bankDetail?.internationalPaymentDetails?.countryCode} height="10" /> : ""}{pmNickName}{paymentMethod?.type === "International" ? ` • ${paymentMethod?.bankDetail?.internationalPaymentDetails?.currency?.toUpperCase()}` : ""}{(paymentMethod.bankDetail.accountNumber) ? ` • ${paymentMethod.bankDetail.accountNumber}` : ""}
            </Text>
        </FlexColumn>
        {
            type == 'Check' ?
                <Text lightText>{checkDeliveryType == 'PostalMail' ? 'Postal Mail' : checkDeliveryType}</Text>
                :
                <Tag primary>{paymentMethod.type}</Tag>
        }

    </Flex>
}

export const railCards = rcs;

export const PaymentMethodOptionV2 = (props) => {
    const theme = useTheme();

    const { paymentMethod, rail } = props
    const { bankDetail, type } = paymentMethod || {}
    const { accountNumber, checkDeliveryType } = bankDetail || {}
    const nickNameMaxLen = 10
    var pmNickName = `${(paymentMethod.nickName || "").trim().substr(0, nickNameMaxLen)}${(paymentMethod.nickName || "").trim().length > nickNameMaxLen ? "..." : ""}`
    var acctChars = (paymentMethod.bankDetail.accountNumber || "").length;

    var railCard = rcs.find(rc => rc.name == paymentMethod.type) || {};
    return (
        <FlexColumn start gap='6px' style={{ padding: "0px 5px" }}>
            <Flex centerH between style={{ width: "100%" }}>
                <FlexColumn start>
                    <Text title={paymentMethod.nickName + ` • ${paymentMethod.bankDetail.accountNumber}`}>
                        {
                            paymentMethod?.type === "International" 
                            ? 
                                <Flag style={{ marginRight: 8 }} code={paymentMethod?.bankDetail?.internationalPaymentDetails?.countryCode} height="10" /> 
                            : 
                                ""
                        }
                        {pmNickName}
                        {
                            paymentMethod?.type === "International" 
                            ? 
                                ` • ${paymentMethod?.bankDetail?.internationalPaymentDetails?.currency?.toUpperCase()}` 
                            : 
                                ""
                        }
                        {
                            (paymentMethod.bankDetail.accountNumber) 
                            ? 
                                ` • ${(paymentMethod.bankDetail.accountNumber).trim().substr(acctChars - 4, acctChars)}` 
                            : 
                                ""
                        }
                        
                    </Text>
                </FlexColumn>
                {
                    type == 'Check' ?
                        <Text lightText>{checkDeliveryType == 'PostalMail' ? 'Postal Mail' : checkDeliveryType}</Text>
                        :
                        null
                }
                <Flex start centerH gap='6px'>
                    <TagV2 style={{ height: '20px' }} centerH color={theme.colors.primary}>{railCard.name}</TagV2>
                    <TagV2 style={{ height: '20px' }} centerH gap='4px' title={railCard.desc}>
                        {railCard.icon}
                        {railCard.tag}
                    </TagV2>
                </Flex>
            </Flex>
            <Flex start centerH gap='4px'>
                <LucideCalendarCheck size='16px' />
                <Text light size='14px' color={hexToRgba(theme.colors.primary2, 0.6)}>{railCard.desc}</Text>
            </Flex>
            
            <Divider margin='8px 0 0 0' />
        </FlexColumn>
        
    )
}

export const RecipientOption = (props) => {
    const { recipient } = props
    return <FlexColumn start fullWidth>
        <Flex start>
            <img width='12px' height='12px' src={recipient.type === "Business" ? Business : Individual} style={{ marginRight: 4, marginBottom: 2 }} />
            <Text capitalize>{recipient.nickName || recipient.nameOnAccount}</Text>
        </Flex>
        <Text lightText>{recipient.email}</Text>
    </FlexColumn>
}

export const BasicOption = (props) => {
    const { value } = props
    return <Flex start fullWidth centerHorizontally>
        <Text>{value}</Text>
    </Flex>
}